import React, { useEffect, useState } from 'react';
import AppApi from "../../api/app";
import toast from 'react-hot-toast';
import gallery from "../../api/gallery";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
import moment from 'moment';
import { Accordion } from 'react-bootstrap';
let validationSchema = Yup.object({
   status: Yup.string().required("Status is required."),
   note: Yup.string().required("Note is required."),
});

function UpdateOrder({ updateList, data, setting, fullAccess = true }) {
   const [orderHistory, setOrderHistory] = useState([]);
   const [historyLoading, setHistory] = useState(false);
   useEffect(() => {
      getOrderHistory(data?._id)
   }, [data?.id]);

   const getOrderHistory = async (id) => {
      try {
         setHistory(true);
         let res = await AppApi.getOrderHistory(id);
         if (res?.data?.error == false) {
            setOrderHistory(res?.data?.data?.data || []);
         }
         setHistory(false)
      } catch (error) {
         console.log(error.message);
         setHistory(false)
      }
   }

   return (
      <>
         <div className="container-fluid">
            <div className="row">
               <div className="col-md-8">
                  {data?._id && (
                     <div className="productSummary">
                        <div className="order-details card  mb-3">
                           <div className="card-header  ">
                              <h5 className="mb-0">Order Details</h5>
                           </div>
                           <div className="card-body">
                              <div className="row mb-2">
                                 <div className="col-sm-2"><b>Order ID:</b></div>
                                 <div className="col-sm-9">#{data?.orderId}</div>
                              </div>
                              <div className="row mb-2">
                                 <div className="col-sm-2"><b>Name:</b></div>
                                 <div className="col-sm-9">{data?.name}</div>
                              </div>
                              <div className="row mb-2">
                                 <div className="col-sm-2"><b>Email:</b></div>
                                 <div className="col-sm-9">{data?.email}</div>
                              </div>
                              <div className="row mb-2">
                                 <div className="col-sm-2"><b>Phone:</b></div>
                                 <div className="col-sm-9">{data?.phoneNumber}</div>
                              </div>
                              <div className="row mb-2">
                                 <div className="col-sm-2"><b>Order Time:</b></div>
                                 <div className="col-sm-9">{moment(data?.orderTime).fromNow()}</div>
                              </div>
                              <div className="row mb-2">
                                 <div className="col-sm-2"><b>Address:</b></div>
                                 <div className="col-sm-9">{data?.address}</div>
                              </div>
                              <div className="row mb-2">
                                 <div className="col-sm-2"><b>Note:</b></div>
                                 <div className="col-sm-9">{data?.note}</div>
                              </div>
                           </div>
                        </div>
                        <Accordion defaultActiveKey={"0"}>
                           <Accordion.Item eventKey="0"
                              className='border-0 rounded-0 px-0'
                           >
                              <Accordion.Header> <i className='fad fa-cart-arrow-down me-1'></i> Order summary ({setting?.currencySymbol} {data.totalCost} || QTY:{data?.productsQuantity})</Accordion.Header>
                              <Accordion.Body>
                                 <ul className='ps-0'>
                                    {data.products?.map((data, index) => {
                                       return (
                                          <li className='cartProductItem  mb-2 d-flex gap-2  '
                                             key={index}
                                          >
                                             <div>
                                                <div className="image-holder border">
                                                   <img src={data?.productId?.image} alt={data?.productId?.name} />
                                                </div>
                                             </div>
                                             <div className="rightContent flex-grow-1">
                                                <div className='title'>{data?.productId?.title}</div>
                                                <div className="price">
                                                   {data?.multiPriceOptionData && JSON.parse(data?.multiPriceOptionData)?.title && (<>{JSON.parse(data?.multiPriceOptionData).title},</>)}
                                                   Qty:{data?.quantity},
                                                   Per Unit: {setting?.currencySymbol} {data?.unitPrice},
                                                   Total Cost:{setting?.currencySymbol} {data?.totalPrice}
                                                </div>
                                                {data?.question && (
                                                   <div className="price">
                                                      <b>{data?.productId?.customInputTitle}</b>: {data.question}
                                                   </div>
                                                )}
                                                {data?.color && (
                                                   <div className='price d-flex align-items-center' >
                                                      <span> Color: </span> <span className='selectedColor ms-1' style={{ backgroundColor: data?.color }}></span>
                                                   </div>
                                                )}
                                             </div>
                                          </li>
                                       )
                                    })}
                                 </ul>

                              </Accordion.Body>
                           </Accordion.Item>
                        </Accordion>
                        <br />
                        {data?.deliveryCost > 0 && (
                           <>
                              <div className="d-flex justify-content-between">
                                 <div>Subtotal</div>
                                 <div>{setting?.currencySymbol} {data.productsCost}</div>
                              </div>
                              <div className="d-flex justify-content-between">
                                 <div>Delivery Cost</div>
                                 <div>{setting?.currencySymbol} {data?.deliveryCost}</div>
                              </div>
                           </>
                        )}
                        <hr />
                        <div className="d-flex justify-content-between">
                           <div>Total</div>
                           <div>{setting?.currencySymbol} {data.totalCost}</div>
                        </div>
                     </div>
                  )}
               </div>
               {fullAccess && (
                  <div className="col-md-4">
                     <h4 className='pb-0'>Order History</h4>
                     <Formik
                        initialValues={{
                           status: data?.status || "",
                           note: ""
                        }}
                        validationSchema={validationSchema}
                        onSubmit={async (values, { setSubmitting, resetForm }) => {
                           setSubmitting(true);
                           try {
                              let apiData = {
                                 status: values.status,
                                 note: values?.note
                              }
                              let res = await AppApi.updateOrderById(data?._id, apiData);
                              if (res?.data?.error == false) {
                                 toast.success(res?.data?.msg);
                              }
                              resetForm();
                              updateList(res?.data?.data);
                              setSubmitting(false);
                           } catch (error) {
                              console.log(error.message);
                              setSubmitting(false);
                           }
                        }}
                     >
                        {({ isSubmitting, values, errors, setFieldValue }) => (
                           <Form>
                              <div className=" form mt-1">
                                 <div className="form-group flex-grow-1">
                                    <label>Order status</label>
                                    <select className="form-control"
                                       defaultValue={data.status}
                                       onChange={(event) => setFieldValue("status", event.target.value)}
                                    >
                                       <option value="PENDING">PENDING</option>
                                       <option value="ACCEPTED">ACCEPTED</option>
                                       <option value="DELIVERED">DELIVERED</option>
                                       <option value="REJECTED">REJECTED</option>
                                       <option value="RETURNED">RETURNED</option>
                                    </select>
                                    <ErrorMessage component="small" className='text-danger' name="status" />
                                 </div>
                                 <div className="form-group flex-grow-1">
                                    <label>Order status</label>
                                    <textarea className="form-control" rows="3"
                                       onChange={(event) => setFieldValue("note", event.target.value)}
                                    >
                                    </textarea>
                                    <ErrorMessage component="small" className='text-danger' name="note" />
                                 </div>
                              </div>
                              <div className="p-0 mt-2 text-left col-sm-12">
                                 <div className="mb-1 form-group">
                                    <button type="submit" disabled={isSubmitting} className="w-100 btn rounded-0 btn-dark">{isSubmitting ? "Loading..." : data?._id ? "Update" : "Add"}</button>
                                 </div>
                              </div>
                           </Form>
                        )}
                     </Formik>
                     <hr />
                     <h4>History</h4>
                     {historyLoading ? "Loading..." : (
                        <>
                           {orderHistory?.length == 0 && (
                              <>
                                 No data found.
                              </>
                           )}
                           <ul className="timeline">
                              {orderHistory?.map((data, index) => (
                                 <li key={index}>
                                    <div className='timeline-content '>
                                       <div className='card p-3'>
                                          <div className='d-flex justify-content-between'>
                                             <div className='badge bg-success'>{data?.deliveryType}</div>
                                             <div>
                                                <small className='ml-2'>{moment(data?.createdAt).fromNow()}</small>
                                             </div>
                                          </div>
                                          <p>{data?.note}</p>
                                       </div>
                                    </div>
                                 </li>
                              ))}
                           </ul>

                        </>
                     )}

                  </div>
               )}

            </div>
         </div>


      </>
   )
}

export default UpdateOrder